module.exports = __webpack_public_path__ + "img/xls.63dfc363.svg";